(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3672],{

/***/ 3723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/cart",
      function () {
        return __webpack_require__(4214);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputVoucher; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7239);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);







function InputVoucher(param) {
    var isValid = param.isValid, codePromo = param.codePromo, selectedResto = param.selectedResto;
    var handleCheckCoupon = function handleCheckCoupon(coupon) {
        if (couponValue == "") return;
        codePromo(coupon);
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_5__/* .postCheckCoupon */ .w1)({
            code: (0,lodash__WEBPACK_IMPORTED_MODULE_6__.lowerCase)(coupon),
            resto: selectedResto
        }).then(function(res) {
            isValid(res.data);
        });
    };
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), couponValue = ref[0], setCouponValue = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .ua7, {
                label: locale == "id" ? "Tekan Enter setelah mengetik Kupon" : "Press Enter after type the Coupon",
                "aria-label": "A tooltip",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                    type: "text",
                    py: 6,
                    placeholder: locale == "id" ? "MASUKKAN KODE PROMO" : "INSERT PROMO CODE",
                    color: "black",
                    borderRadius: 0,
                    textAlign: "center",
                    textTransform: "uppercase",
                    _placeholder: {
                        textTransform: "uppercase"
                    },
                    onChange: function(e) {
                        setCouponValue(e.target.value);
                    },
                    onKeyDown: function(e) {
                        if (e.key == "Enter") {
                            handleCheckCoupon(e.currentTarget.value);
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                variant: "solid",
                h: "100%",
                bg: "black",
                color: "white",
                onClick: function() {
                    return handleCheckCoupon(couponValue);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoChevronForwardOutline */ .nQU, {
                    size: 26
                })
            })
        ]
    });
};


/***/ }),

/***/ 4214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_Input_InputVoucher__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5819);
/* harmony import */ var _components_LinkTo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6269);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9735);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

















var __N_SSG = true;
function Home(param) {
    var header = param.header, hotelBrands = param.hotelBrands;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), query = ref.query, isReady = ref.isReady, push = ref.push, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), cartItems = ref1[0], setCartItems = ref1[1];
    // const [price, setPrice] = useState([{ amount: 0, total: 0 }]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), amount = ref2[0], setAmount = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), quantity = ref3[0], setQuantity = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), total = ref4[0], setTotal = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), isVoucherValid1 = ref5[0], setIsVoucherValid = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), voucher1 = ref6[0], setVoucher = ref6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var now = function now() {
            var tempList = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("cart");
            if (!tempList) {
                setCartItems([]);
                return;
            }
            var tempItems = tempList.map(function(item) {
                var temp = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)(item);
                return temp;
            });
            setCartItems(tempItems);
            var tempVoucher = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("shop-voucher");
            if (tempVoucher) {
                setVoucher(tempVoucher);
                (0,_utils_api__WEBPACK_IMPORTED_MODULE_15__/* .postCheckCoupon */ .w1)({
                    code: tempVoucher
                }).then(function(res) {
                    setIsVoucherValid(res.data);
                });
            }
        };
        now();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var aTemp = 0, qTemp = 0;
        var dTemp = 0;
        cartItems.map(function(v) {
            qTemp = qTemp + v.quantity;
            aTemp = aTemp + v.price * v.quantity;
        });
        setAmount(aTemp);
        setQuantity(qTemp);
        var totalTemp = aTemp - dTemp;
        if (isVoucherValid1 && isVoucherValid1.isUsable) {
            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .setLocalStorage */ .qQ)("shop-voucher", voucher1);
            var tempDisc = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.toNumber)(isVoucherValid1.amount.replace(".00", ""));
            if (isVoucherValid1.discount_type == "percent") {
                setTotal(totalTemp - totalTemp * (tempDisc / 100));
            } else {
                setTotal(totalTemp - tempDisc > 0 ? totalTemp - tempDisc : 0);
            }
        } else {
            setTotal(totalTemp);
        }
    }, [
        cartItems,
        isVoucherValid1
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "My Cart | Parador Hotels & Resorts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                headerItem: header,
                hotelBrands: hotelBrands,
                isHomepage: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                as: "h1",
                                m: 0,
                                mb: 2,
                                fontWeight: 400,
                                letterSpacing: "widest",
                                color: "black",
                                children: locale == "id" ? "BELANJA" : "SHOP"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                m: 0,
                                maxW: {
                                    base: "90%",
                                    md: "50%"
                                },
                                align: "left",
                                color: "blackAlpha.700",
                                children: locale == "id" ? "Nikmati penawaran & promosinya" : "Enjoy the offers & promotions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                        mb: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                            orientation: "horizontal",
                            borderColor: "blackAlpha.500"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        mb: 0,
                        as: "h1",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        textAlign: "left",
                        children: locale == "id" ? "KERANJANG" : "MY CART"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                        gap: 16,
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                flex: 2,
                                flexDir: "column",
                                children: [
                                    cartItems.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                        align: "center",
                                        gap: 1,
                                        mb: 4,
                                        color: "blackAlpha.700",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoChevronBack */ .dUf, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                href: "/shop",
                                                children: locale == "id" ? "Tambah Item Lagi" : "Add More Item"
                                            })
                                        ]
                                    }),
                                    cartItems.length > 0 ? cartItems.map(function(item, i) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                    mb: 4,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                                                        orientation: "horizontal",
                                                        borderColor: "blackAlpha.300"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                    mb: 12,
                                                    gap: 6,
                                                    color: "blackAlpha.700",
                                                    flexDir: [
                                                        "column",
                                                        null,
                                                        null,
                                                        "row"
                                                    ],
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AspectRatio */ .oM5, {
                                                            maxW: "300px",
                                                            w: "100%",
                                                            h: "100%",
                                                            position: "relative",
                                                            ratio: 4 / 3,
                                                            children: item && item.thumb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                src: item.thumb,
                                                                layout: "fill",
                                                                alt: "",
                                                                objectFit: "cover",
                                                                priority: true,
                                                                unoptimized: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                                                    as: "h3",
                                                                    fontWeight: 500,
                                                                    letterSpacing: "wider",
                                                                    fontSize: "xl",
                                                                    mb: 8,
                                                                    cursor: "pointer",
                                                                    onClick: function() {
                                                                        return push("/shop/detail?product=".concat(item.slug));
                                                                    },
                                                                    children: locale == "id" && item.name_id ? item.name_id : item.name
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                                                                        columns: 2,
                                                                        rowGap: 4,
                                                                        columnGap: 16,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                                                                as: "h3",
                                                                                fontWeight: 500,
                                                                                letterSpacing: "wider",
                                                                                fontSize: "xl",
                                                                                children: locale == "id" ? "Harga" : "Price"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                                                                as: "h3",
                                                                                fontWeight: 500,
                                                                                letterSpacing: "wider",
                                                                                fontSize: "xl",
                                                                                children: locale == "id" ? "Kuantitas" : "Quantity"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                                fontWeight: 500,
                                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(item.price)
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                                align: "center",
                                                                                gap: 2,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                                        justify: "space-between",
                                                                                        align: "center",
                                                                                        w: 120,
                                                                                        p: 2,
                                                                                        borderColor: "gray.300",
                                                                                        color: "gray.600",
                                                                                        borderWidth: 1,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                                                                cursor: "pointer",
                                                                                                color: "gray.600",
                                                                                                onClick: function() {
                                                                                                    var itemsTemp = _toConsumableArray(cartItems);
                                                                                                    if (item.quantity == 1) {
                                                                                                        var slugs = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("cart");
                                                                                                        slugs = slugs.filter(function(e) {
                                                                                                            return e !== item.slug;
                                                                                                        });
                                                                                                        itemsTemp.splice(i, 1);
                                                                                                        setCartItems(itemsTemp);
                                                                                                        (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .setLocalStorage */ .qQ)("cart", slugs);
                                                                                                        (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .deleteLocalStorage */ .bv)(item.slug);
                                                                                                        return;
                                                                                                    }
                                                                                                    var itemTemp = _objectSpread({}, itemsTemp[i]);
                                                                                                    itemTemp.quantity = item.quantity - 1;
                                                                                                    itemsTemp[i] = itemTemp;
                                                                                                    setCartItems(itemsTemp);
                                                                                                    (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .setLocalStorage */ .qQ)(item.slug, itemTemp);
                                                                                                },
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoRemoveSharp */ .PS1, {
                                                                                                    size: 24
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                                                fontSize: "xl",
                                                                                                as: "span",
                                                                                                children: item.quantity
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                                                                cursor: item.quantity < item.maxQuantity && quantity < 3 ? "pointer" : "not-allowed",
                                                                                                color: item.quantity < item.maxQuantity && quantity < 3 ? "gray.600" : "gray.300",
                                                                                                onClick: function() {
                                                                                                    var itemsTemp = _toConsumableArray(cartItems);
                                                                                                    if (!(item.quantity < item.maxQuantity)) {
                                                                                                        return;
                                                                                                    }
                                                                                                    if (quantity >= 3) return;
                                                                                                    var itemTemp = _objectSpread({}, itemsTemp[i]);
                                                                                                    itemTemp.quantity = item.quantity + 1;
                                                                                                    itemsTemp[i] = itemTemp;
                                                                                                    setCartItems(itemsTemp);
                                                                                                    (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .setLocalStorage */ .qQ)(item.slug, itemTemp);
                                                                                                },
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoAddSharp */ .Z2A, {
                                                                                                    size: 24
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                                                        cursor: "pointer",
                                                                                        color: "gray.600",
                                                                                        onClick: function() {
                                                                                            var itemsTemp = _toConsumableArray(cartItems);
                                                                                            var slugs = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("cart");
                                                                                            slugs = slugs.filter(function(e) {
                                                                                                return e !== item.slug;
                                                                                            });
                                                                                            itemsTemp.splice(i, 1);
                                                                                            setCartItems(itemsTemp);
                                                                                            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .setLocalStorage */ .qQ)("cart", slugs);
                                                                                            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .deleteLocalStorage */ .bv)(item.slug);
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoClose */ .bjh, {
                                                                                            size: 24
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.slug)
                                            ]
                                        }, i);
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                            color: "blackAlpha.700",
                                            children: [
                                                "Cart is Empty. go to",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkTo__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    activeColor: "black",
                                                    to: "/shop",
                                                    style: {
                                                        color: "black",
                                                        cursor: "pointer",
                                                        fontWeight: 500
                                                    },
                                                    children: "Shop Page"
                                                }),
                                                " ",
                                                "to fill your cart."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                flexDir: "column",
                                align: "center",
                                maxW: [
                                    "100%",
                                    null,
                                    null,
                                    "25%"
                                ],
                                flex: 1,
                                color: "blackAlpha.600",
                                gap: 6,
                                children: [
                                    isVoucherValid1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                                        bg: isVoucherValid1.isUsable ? "blackAlpha.600" : "red.400",
                                        w: "full",
                                        p: 3,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                            fontSize: "small",
                                            fontWeight: 500,
                                            textTransform: "uppercase",
                                            letterSpacing: "wide",
                                            color: "white",
                                            children: isVoucherValid1.isUsable ? "".concat(locale == "id" ? "Promo dipakai:" : "Promo used:", " ").concat(voucher1) : locale == "id" ? "Kode promo salah" : "Promo code is invalid"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                        flexDir: "column",
                                        borderWidth: 1,
                                        borderRadius: 16,
                                        borderColor: "blackAlpha.200",
                                        w: "100%",
                                        gap: 3,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                pt: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "JUMLAH" : "AMOUNT"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(amount)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "KUANTITAS" : "QUANTITY"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: quantity
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "BIAYA ANTAR" : "DELIVERY FEE"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "GRATIS" : "FREE"
                                                    })
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "TIPE PENGIRIMAN" : "DELIVERY TYPE"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: "Regular"
                                                    })
                                                ]
                                            }),
                                            isVoucherValid1 && isVoucherValid1.isUsable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                                                            orientation: "horizontal"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                        justify: "space-between",
                                                        fontSize: "xs",
                                                        fontWeight: 500,
                                                        px: 6,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                as: "span",
                                                                children: locale == "id" ? "DISKON" : "DISCOUNT"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                as: "span",
                                                                children: [
                                                                    isVoucherValid1.discount_type == "percent" ? isVoucherValid1.amount.replace(".00", "") : (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(isVoucherValid1.amount.replace(".00", "")),
                                                                    isVoucherValid1.discount_type == "percent" && "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                mb: -0.2,
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 600,
                                                bg: "blackAlpha.200",
                                                color: "blackAlpha.700",
                                                p: 6,
                                                borderBottomRadius: 15,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: "TOTAL"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(total)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Input_InputVoucher__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        codePromo: function(voucher) {
                                            return setVoucher(voucher);
                                        },
                                        isValid: function(isVoucherValid) {
                                            return setIsVoucherValid(isVoucherValid);
                                        },
                                        selectedResto: 0
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                                        bg: "black",
                                        color: "white",
                                        w: "100%",
                                        py: 6,
                                        fontSize: "md",
                                        onClick: function() {
                                            if (voucher1) {
                                                setVoucher(voucher1);
                                                (0,_utils_api__WEBPACK_IMPORTED_MODULE_15__/* .postCheckCoupon */ .w1)({
                                                    code: voucher1
                                                }).then(function(res) {
                                                    setIsVoucherValid(res.data);
                                                    (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .setLocalStorage */ .qQ)("shop-voucher", voucher1);
                                                });
                                            }
                                            push("/shop/cart/checkout");
                                        },
                                        disabled: !(cartItems.length > 0) || quantity > 3,
                                        children: locale == "id" ? "Pembayaran" : "Checkout"
                                    }),
                                    quantity >= 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                        fontSize: "xs",
                                        color: "red.500",
                                        children: locale == "id" ? "Mohon maaf, maksimal 3 barang dalam 1 troli. Mohon untuk melakukan sesi pembelian lain jika barang sudah terisi 3 barang" : "Sorry, maximum 3 items in 1 cart. Please make a new purchase session if the cart is filled with 3 items"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 1082:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,3981,9774,2888,179], function() { return __webpack_exec__(3723); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);